import styled from 'styled-components';

export const RightBlockMainWrap = styled.div(
    props => `
        width:25%;
        display: flex;
        flex-direction: column;
    `
)